/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ day: NonNullable<unknown> }} Plan_Edit_Moved_To_ToastInputs */

const en_us2_plan_edit_moved_to_toast = /** @type {(inputs: Plan_Edit_Moved_To_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Moved to ${i?.day}`)
};

const pt_br2_plan_edit_moved_to_toast = /** @type {(inputs: Plan_Edit_Moved_To_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Movido para ${i?.day}`)
};

const es_419_plan_edit_moved_to_toast = /** @type {(inputs: Plan_Edit_Moved_To_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Movido a ${i?.day}`)
};

const pt_pt2_plan_edit_moved_to_toast = /** @type {(inputs: Plan_Edit_Moved_To_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Movido para ${i?.day}`)
};

const fr_fr2_plan_edit_moved_to_toast = /** @type {(inputs: Plan_Edit_Moved_To_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Déplacé vers ${i?.day}`)
};

const de_de2_plan_edit_moved_to_toast = /** @type {(inputs: Plan_Edit_Moved_To_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nach ${i?.day} verschoben`)
};

const it_it2_plan_edit_moved_to_toast = /** @type {(inputs: Plan_Edit_Moved_To_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Spostato a ${i?.day}`)
};

/**
* | output |
* | --- |
* | "Moved to {day}" |
*
* @param {Plan_Edit_Moved_To_ToastInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_edit_moved_to_toast = /** @type {((inputs: Plan_Edit_Moved_To_ToastInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Edit_Moved_To_ToastInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_edit_moved_to_toast(inputs)
	if (locale === "es-419") return es_419_plan_edit_moved_to_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_edit_moved_to_toast(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_edit_moved_to_toast(inputs)
	if (locale === "de-DE") return de_de2_plan_edit_moved_to_toast(inputs)
	if (locale === "it-IT") return it_it2_plan_edit_moved_to_toast(inputs)
	return en_us2_plan_edit_moved_to_toast(inputs)
});
export { plan_edit_moved_to_toast as "plan-edit.moved_to_toast" }